import "./Step1.scss";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import InsButton from "../../../../components/InsButton/InsButton";
import InsInput from "../../../../components/InsInput/InsInput";
import StepCount from "../../../../components/StepCount/StepCount";
import { autocomplete } from "../../../../api/account";
import InsAutocomplete from "../../../../components/InsAutocomplete/InsAutocomplete";
import { connect } from "react-redux";
import Validate from "../../../../ressources/validation";
import Select from "react-select";

class Step1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      autocomplete: {},
      acFocus: "",
      acAddress: false,
      countries: [],
      fields: [],
      storeId: this.props.userInfo["store"] || "",
    };

    this.apiUrl = process.env.REACT_APP_API;
  }

  static propTypes = {
    onValidate: PropTypes.func,
    userInfo: PropTypes.any,
  };

  componentDidUpdate() {
    if (this.state.countries !== this.props.config.hub_countries) {
      const { hub_countries } = this.props.config;

      this.setState({
        countries: hub_countries,
      });
    }
  }

  componentDidMount() {
    const { config } = this.props;
    const { shop } = config.register;
    const { hub_countries } = config;
    // const {
    //   retailer,
    //   shop_name,
    //   city,
    //   address
    // } = this.props.config.register.shop;
    // if (!retailer && !shop_name && !city && !address) {
    //   const userInfo = {
    //     store: {
    //       retailer: null,
    //       city: null,
    //       name: null,
    //       address: null
    //     }
    //   };
    //   onValidate(userInfo);
    // }
    this.setState({
      fields: shop.map((field) => ({
        ...field,
        value: this.props.userInfo[field.name] || "",
        error: "",
        label: this.props.userInfo[field.name] || "",
        autocomplete: false,
      })),
      countries: hub_countries,
    });
  }

  _handleChange = (input) => (e) => {
    const value = e.target.value;
    const { fields } = this.state;

    const index = fields.findIndex((el) => el.name === input);
    let newFields = [...fields];
    newFields[index].value = value;
    if (!newFields[index].value.length) {
      this.clearForm();
    } else {
      this.setState(
        {
          acFocus: input,
          fields: newFields,
        },
        () => {
          if (value.length >= 1) {
            if (this.handleChangeTimer) {
              clearTimeout(this.handleChangeTimer);
            }
            this.handleChangeTimer = setTimeout(() => {
              this.autocompleteRequest();
            }, 500);
          }
          // else if (
          //   name.length >= 3 ||
          //   city.length >= 3 ||
          //   retailer.length >= 3
          // )
          //   {
          //   this.autocompleteRequest();
          // }
        }
      );
    }
  };

  _handleCountry = (option) => {
    // const {fields} = this.state
    const { shop } = this.props.config.register;
    // const index = fields.findIndex((el) => el.name === "country")
    let newFields = shop.map((field, index) => {
      return {
        ...field,
        value: field.name === "country" ? option.value : "",
        error: "",
      };
    });
    this.setState({ fields: newFields }, () => {
      this._validateField("country")();
      this.autocompleteRequest();
    });
  };

  // Clear all fields
  clearForm = () => {
    const { fields } = this.state;
    const { config } = this.props;
    const { shop } = config.register;
    const { hub_countries } = config;
    let initialState = {
      autocomplete: [],
      acFocus: "",
      acAddress: false,
      fields: shop.map((field, index) => {
        return {
          ...field,
          value: field.name === "country" ? fields[index].value : "",
          error: "",
        };
      }),
      countries: hub_countries,
    };
    this.setState(initialState);
  };

  autocompleteRequest = (generation = false) => {
    const { fields } = this.state;

    let obj = {};
    fields.forEach((field) => {
      if (field.value.length) {
        obj[field.name] = field.value.trim();
      }
    });

    autocomplete(obj).then((data) => {
      // this.setState({ countries: data.country });
      this.setState({ autocomplete: data });
      if (generation) {
        Object.keys(data).forEach((item) => {
          const index = fields.findIndex((el) => el.name === item);
          let newFields = [...fields];

          if (data[item].length === 1) {
            if (item === "country") {
              newFields[index].value = data[item][0].value;
            } else {
              newFields[index].value = data[item][0];
            }
            this.setState({ fields: newFields, storeId: data.id }, () => {
              fields.forEach((el) => this._validateField(el.name)(true));
            });
          }
        });
      }
    });
  };

  showAutocomplete = (name) => () => {
    clearTimeout(this.setTimeOutAutoComplete);
    this.setState({ acFocus: name });
  };

  _onClickAutocomplete = (input) => (value) => {
    const { fields } = this.state;
    const index = fields.findIndex((el) => el.name === input);
    let newFields = [...fields];
    newFields[index].value = value;
    newFields.forEach((el) => {
      el.autocomplete = true;
    });
    this.setState(
      {
        fields: newFields,
        acFocus: "",
      },
      () => {
        this.autocompleteRequest(true);
      }
    );
  };

  _clearInput = (input) => {
    const { fields } = this.state;
    let newFields = [...fields];
    newFields.forEach((el) => {
      el.value = "";
      el.autocomplete = false;
    });
    this.setState({
      fields: newFields,
      autocomplete: {},
    });
  };

  _validateField =
    (input) =>
    (displayError = true) => {
      const { fields } = this.state;
      const index = fields.findIndex((el) => el.name === input);
      if (!fields[index].required) {
        return true;
      }
      const error =
        Validate("required", fields[index].value) ||
        Validate(fields[index].name, fields[index].value);
      if (displayError) {
        let newFields = [...fields];
        newFields[index].error = error;
        this.setState({
          fields: newFields,
        });
      }
      return !error;
    };

  _onValidate = () => {
    const { onValidate } = this.props;
    const { storeId, fields } = this.state;
    let store = {};
    fields.forEach((el) => {
      if(el.name === "retailer" && el.value?.value) {
        store[el.name] = el.value?.name;
        store[`${el.name}_code`] = el.value?.value;
      } else {
        store[el.name] = el.value;
      }
    });
    store.store = storeId;
    const userInfo = store;
    onValidate(userInfo);
  };

  /**
   * Valide le formulaire de l'étape
   */
  _validateFormStep = () => {
    const { fields } = this.state;
    return fields.every((el) => this._validateField(el.name)(false));
  };

  _fieldAddress = (field) => {
    const { t } = this.props;
    const { acFocus, autocomplete } = this.state;

    return (
      <div className="input_container">
        <InsInput
          name={field.name}
          onChange={this._handleChange(field.name)}
          onFocus={this.showAutocomplete(field.name)}
          maxLength="115"
          placeholder={field.required ? t(field.name) + " *" : t(field.name)}
          value={field.value}
          autoComplete="new-password"
          readOnly
          error={field.error}
        />
        <InsAutocomplete
          visible={acFocus === field.name}
          values={autocomplete[field.name]}
          onClick={this._onClickAutocomplete(field.name)}
        />
        {field.value.length ? (
          <div
            className="clear_input"
            onClick={() => this._clearInput(field.name)}
          >
            &#10006;
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  _fields = (field) => {
    const { t, config } = this.props;
    const { autocomplete, acFocus } = this.state;
    return (
      <div className="input_container">
        <InsInput
          name={field.name}
          onChange={this._handleChange(field.name)}
          onFocus={this.showAutocomplete(field.name)}
          onBlur={() => {
            this._validateField(field.name)();
            this.setTimeOutAutoComplete = setTimeout(() => {
              this.showAutocomplete("")();
            }, 300);
          }}
          placeholder={field.required ? t(field.name) + " *" : t(field.name)}
          value={field.value?.name || field.value || ""}
          autoComplete="new-password"
          error={field.error}
          readOnly={field.autocomplete}
          country={config.country}
        />
        <InsAutocomplete
          visible={acFocus === field.name}
          values={autocomplete[field.name]}
          onClick={this._onClickAutocomplete(field.name)}
        />
        {field.autocomplete || field.value.length ? (
          <div
            className="clear_input"
            onClick={() => this._clearInput(field.name)}
          >
            &#10006;
          </div>
        ) : (
          ""
        )}
        {config.country === "SPAIN" && field.name === "retailer" && (
          <div className="field_note">{t('register_retailer_helper')}</div>
        )}
      </div>
    );
  };

  _fieldCountry = (field) => {
    const { t } = this.props;
    const { fields, countries } = this.state;

    const index = fields.findIndex((el) => el.name === field.name);
    let newFields = [...fields];

    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        backgroundColor: "white",
        color: "black",
      }),
      control: (provided, state) => ({
        ...provided,
        backgroundColor: "transparent",
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "white",
      }),
    };

    countries.map((country) => (country.label = country.name));

    return (
      <div className={field.error ? "ins_input mb20 error" : "ins_input mb20"}>
        <Select
          isSearchable={false}
          classNamePrefix={field.name}
          menuPlacement="bottom"
          styles={customStyles}
          className={field.name}
          value={{
            value: newFields[index].value,
            label: (
              <div className="ls-row">
                {newFields[index].value
                  ? countries.find(
                      (country) => country.value === newFields[index].value
                    ).label
                  : newFields[index].required
                  ? t(field.name) + " *"
                  : t(field.name)}
              </div>
            ),
          }}
          onChange={this._handleCountry}
          options={countries}
        />
        {field.error && (
          <div className={"error-" + field.name}>{field.error}</div>
        )}
      </div>
    );
  };

  render() {
    const { t, currentStep, maxSteps } = this.props;
    const { fields } = this.state;
    return (
      <form
        className="default-container col-flex"
        onSubmit={(e) => e.preventDefault()}
      >
        <StepCount step={currentStep} maxStepCount={maxSteps} />
        <p className="bold-label centered mb50">{t("step1")}</p>
        {fields.map((field) => {
          switch (field.name) {
            case "address":
              return <div key={field.name}>{this._fieldAddress(field)}</div>;

            case "country": {
              if (this.state.countries.length < 2) {
                return <div key={field.name}></div>;
              }
              return <div key={field.name}>{this._fieldCountry(field)}</div>;
            }

            default:
              return <div key={field.name}>{this._fields(field)}</div>;
          }
        })}

        <div className="bottom-container">
          {!this._validateFormStep() && (
            <div className="alert_msg mb10">{t("required")}</div>
          )}
          <InsButton
            text={t("next")}
            onClick={this._onValidate}
            disabled={!this._validateFormStep()}
          />
        </div>
      </form>
    );
  }
}
const mapStateToProps = (state) => ({
  config: state.config,
});

export default connect(mapStateToProps)(withTranslation()(Step1));
